import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component';
import { isArray, isEmpty } from 'lodash';
import * as damAction from '../../../Pages/DAM/store/DAM.action';
import { fetchProductDamTag } from '../../../Pages/DevlopmentOrder/Dam/DamFiles/store/DamFile.action';
import { customStyles } from '../../helper';

export function DAMSetting({ obj, updateSetting }) {
  const { t } = useTranslation('common');
  const reducer = useSelector((reducerstate) => reducerstate);
  const { damModule } = reducer;
  const { allDamFolderList } = damModule;
  const [tagListOption, setTagListOption] = useState([]);
  const locationOption = [
    { label: 'DAM', value: 'DAM' },
    { label: 'Product DAM', value: 'productDAM' },
  ];
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchDAMDetails = async () => {
      await Promise.all([dispatch(damAction.fetchAllDAmFolders())]);
    };
    fetchDAMDetails();
  }, [dispatch]);

  const fileTypeOptions = [
    {
      label: 'JPEG',
      value: 'image/jpeg',
    },
    {
      label: 'PNG',
      value: 'image/png',
    },
    {
      label: 'WEBP',
      value: 'image/webp',
    },
    {
      label: 'MP4',
      value: 'video/mp4',
    },
    {
      label: 'WEBM',
      value: 'video/webm',
    },
    {
      label: 'MOV',
      value: 'video/mov',
    },
  ];

  useEffect(() => {
    const fetchDamTagList = async () => {
      let tagsData = [];
      if (obj?.relation?.location === 'DAM') {
        tagsData = await dispatch(damAction.fetchDamTag());
      } else {
        tagsData = await dispatch(fetchProductDamTag());
      }
      const updatedObj = tagsData.map((ele) => {
        return { label: ele?.name, value: ele?._id };
      });
      setTagListOption(updatedObj);
    };
    if (obj?.relation?.location) {
      fetchDamTagList();
    }
  }, [dispatch, obj?.relation?.location]);

  const handleSelect = (value, key) => {
    const objData = obj;
    if (key === 'location') {
      objData.moduleName = value?.value;
      objData.relation.tags = [];
    }
    objData.relation[key] = isArray(value) ? value : value.value || value?._id;
    updateSetting(objData);
  };
  return (
    <>
      <div className="common-react-select">
        <p className="field-name">
          {t('DPP.CONTROL.DAM.LOCATION')}
          <span className="asterisk">*</span>
        </p>

        <Select
          placeholder={t('DPP.CONTROL.DAM.SELECT_LOCATION')}
          options={locationOption}
          styles={customStyles}
          className="common-select"
          classNamePrefix="common-select"
          getOptionLabel={({ label }) => `${label}`}
          getOptionValue={({ value }) => `${value}`}
          value={locationOption?.find((ele) => ele?.value === obj?.relation?.location) || null}
          onChange={(selected) => handleSelect(selected, 'location')}
        />
      </div>
      <div className="common-react-select">
        <p className="field-name">
          {t('DPP.CONTROL.DAM.ATTRIBUTE')}
          <span className="asterisk">*</span>
        </p>

        <Select
          placeholder={t('DPP.CONTROL.DAM.SELECT_ATTRIBUTE')}
          options={allDamFolderList}
          styles={customStyles}
          className="common-select"
          classNamePrefix="common-select"
          getOptionLabel={({ name }) => `${name}`}
          getOptionValue={({ _id }) => `${_id}`}
          value={allDamFolderList?.find((ele) => ele?._id === obj?.relation?.attribute) || null}
          onChange={(selected) => handleSelect(selected, 'attribute')}
        />
      </div>
      <div className="common-react-select">
        <p className="field-name">{t('DPP.CONTROL.DAM.CONTENT_TYPE')}</p>
        <MultiSelect
          name="group"
          options={fileTypeOptions}
          className="product-custom-multiselect common-new-multiselect w-100"
          labelledBy="Select file type"
          onChange={(selected) =>
            handleSelect(
              selected.map((val) => val.value),
              'contentType',
            )
          }
          value={fileTypeOptions.filter((val) => !isEmpty(obj?.relation?.contentType) && obj?.relation?.contentType.includes(val.value))}
        />
      </div>
      <div className="common-react-select">
        <p className="field-name">{t('DPP.CONTROL.DAM.TAGS')}</p>
        <MultiSelect
          name="group"
          options={tagListOption}
          className="product-custom-multiselect common-new-multiselect w-100"
          labelledBy="Select file type"
          onChange={(selected) =>
            handleSelect(
              selected.map((val) => val.label),
              'tags',
            )
          }
          value={tagListOption.filter((val) => !isEmpty(obj?.relation?.tags) && obj?.relation?.tags.includes(val.label))}
        />
      </div>
    </>
  );
}

export default DAMSetting;
